import Vue from 'vue'
import Router from 'vue-router'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch((error) => error)
}

Vue.use(Router)

const defaultSettings = require('../settings')
const name = defaultSettings.title

const router = new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/homeTougao',
            name: 'Home',
            component: (resolve) => require(['@/views/home/index'], resolve),
            meta: {
                title: name
            }
        },
        {
            path: '/my',
            name: 'My',
            component: (resolve) => require(['@/views/my/index'], resolve),
            meta: {
                title: name
            }
        },
        {
            path: '/tougao',
            name: 'Tougao',
            component: (resolve) => require(['@/views/tougao/tougao'], resolve),
            meta: {
                title: name
            }
        },
        {
            path: '/confirm',
            name: 'Confirm',
            component: (resolve) => require(['@/views/tougao/confirm'], resolve),
            meta: {
                title: name
            }
        },
        {
            path: '/confirm_new',
            name: 'ConfirmNew',
            component: (resolve) => require(['@/views/tougao/confirm_new'], resolve),
            meta: {
                title: name
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: (resolve) => require(['@/views/login/index'], resolve),
            meta: {
                title: name
            }
        },
        { path: '*', redirect: '/homeTougao' }
    ]
})

export default router
